import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

interface GuestIdContextType {
  guestId: string | null;
  isLoading: boolean;
  isGuest: boolean;
}

const GuestIdContext = createContext<GuestIdContextType>({
  guestId: null,
  isLoading: true,
  isGuest: true,
});

const useGuestId = (): GuestIdContextType => {
  const context = useContext(GuestIdContext);
  if (!context) {
    throw new Error('useGuestId must be used within a GuestIdProvider');
  }
  return context;
};

export { useGuestId };

interface GuestIdProviderProps {
  children: React.ReactNode;
}

export const GuestIdProvider: React.FC<GuestIdProviderProps> = ({ children }) => {
  // 組件渲染日誌已移除
  
  // 最簡化版本，只測試是否能渲染
  const [guestId, setGuestId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isGuest, setIsGuest] = useState(false);
  
  // 測試日誌已移除

  return (
    <GuestIdContext.Provider value={{ guestId, isLoading, isGuest }}>
      {children}
    </GuestIdContext.Provider>
  );
}; 